import { render, staticRenderFns } from "./VideoGroup.vue?vue&type=template&id=b39af294&scoped=true&"
import script from "./VideoGroup.vue?vue&type=script&lang=js&"
export * from "./VideoGroup.vue?vue&type=script&lang=js&"
import style0 from "./VideoGroup.vue?vue&type=style&index=0&id=b39af294&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b39af294",
  null
  
)

export default component.exports